<script>
    import {Listeners} from "../../../constants/listeners";
    import {nextTick} from "vue";
    import {store} from "../../../page/clustering/store";
    import ActionsContainer from "./actions-container.vue";
    import Button from "primevue/button";

    export default {
        data() {
            return {
                rollUp: false,
                style: {},
                selectedTo: [],
                store: store,
            }
        },
        mounted: function () {
            this.$emitter.on(Listeners.KS_TABLE_CHECKBOX_SELECTED, eventData => this.selectedTo = eventData);
        },

        methods: {
            move(id) {
                this.$emitter.emit(Listeners.CLUSTER_MOVE_KEYS, {
                    to: id,
                    ids: this.selectedTo,
                    from: this.getSelectNode.id
                });
            },
            moveKeys() {
                this.$emitter.emit(Listeners.CLUSTER_MOVE_KEYS_FROM_FILTER, {
                    filter: this.$parent.$refs.filter.getQuery(),
                    allSelected: this.$parent.$refs.ksTable.$refs.vuetable.allSelected,
                    selectedTo: this.$parent.$refs.ksTable.$refs.vuetable.selectedTo
                });
            },
            moveNode() {
                this.$emitter.emit(Listeners.CLUSTER_CREATE_NODE_FROM_FILTER, {
                    filter: this.$parent.$refs.filter.getQuery(),
                    selectedTo: this.$parent.$refs.ksTable.$refs.vuetable.selectedTo
                });
            },
            clearSelectedTo() {
                this.$emitter.emit(Listeners.KS_TABLE_CLEAR_SELECTED_TO);
            },
            handleScroll() {
                if (document.getElementsByClassName('ks-button-panel').length === 0) {
                    return;
                }

                let table = document.getElementsByClassName('vuetable')[0],
                    panel = document.getElementsByClassName('ks-button-panel')[0];

                if((window.innerHeight - 200) >= (table.getBoundingClientRect().height + table.getBoundingClientRect().top + 70)){
                    this.style = {
                        top: (table.getBoundingClientRect().height + table.getBoundingClientRect().top + 70) + 'px',
                    }
                }else{
                    this.style = {
                        top: (window.innerHeight - 200) + 'px'
                    };
                }
            }
        },
        computed: {
            getSelectNode() {
                return this.store.getters.selectNode();
            },
            panelStyle() {
                return Object.assign({}, this.style, this.rollUp ? {padding: '15px', opacity: 0.5} : {});
            },

        },
        watch: {
            selectedTo: function (val) {
                let self = this;
                nextTick(() => {
                    self.handleScroll();
                });
            }
        },
        created: function () {
            window.addEventListener('scroll', this.handleScroll);
            this.handleScroll();
        },
        destroyed: function () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        components: {
            ActionsContainer,
            Button,
        }
    }
</script>

<template>
    <ActionsContainer :panelStyle="panelStyle" :selectedCount="selectedTo.length">
        <template #buttons>
            <Button icon="fa fa-archive" @click="move(-1)" :title="$t('lang.main.table.components.cluster_keys.move_undistributed')" size="small" />
            <Button icon="fa fa-trash-o" @click="move(-2)" :title="$t('lang.main.table.components.cluster_keys.move_deleted')" size="small" />
            <Button icon="fa fa-exchange" @click="moveKeys" :title="$t('lang.main.table.components.cluster_keys.move_another_folder')" size="small" />
            <Button icon="fa fa-object-group" @click="moveNode" :title="$t('lang.main.table.components.cluster_keys.create_folder')" size="small" />
            <Button @click="clearSelectedTo" :label="$t('lang.main.btn.clear')" severity="secondary" size="small" />
        </template>
    </ActionsContainer>
</template>
